import baseAPI from '../../axiosApi'

const api={
    list:'/api-ir/office/seal/page',
    add:'/api-ir/office/seal/add',
    update:'/api-ir/office/seal/edit',
    info:'/api-ir/office/seal/',
    del:'/api-ir/office/seal/',
    approve:'/api-ir/office/seal/approve',
    export:'/api-ir/office/seal/export/',
    batchApprove:'/api-ir/office/seal/batch/',
    exportXls:'/api-ir/office/seal/exportXls',
}
// 查询列表
export function list (data) {
    return baseAPI.axiosData(api.list,'get',data)
}
// 新增
export function add (data) {
    return baseAPI.axiosData(api.add,'post',data)
}
// 修改
export function update (data) {
    return baseAPI.axiosData(api.update,'put',data)
}
// 查询
export function info (id) {
    return baseAPI.axiosData(api.info+id,'get')
}
// 删除
export function del (id) {
    return baseAPI.axiosData(api.del+id,'delete')
}
// 审核
export function approve (data) {
    return baseAPI.axiosData(api.approve,'post',data)
}

// 导出
export function exportFile (id) {
    return baseAPI.axiosData(api.export+id,'get')
}

// 导出
export function exportXlsFile (data) {
    return baseAPI.axiosData(api.exportXls+"?"+data,'get')
}

// 平行班审核
export function batchApprove (approvalStatus,data) {
    return baseAPI.axiosData(api.batchApprove+approvalStatus,'post',data)
}